module.exports = __webpack_public_path__ + "img/water-bilige-sensor.5bd3b307.svg";